import { render, staticRenderFns } from "./BlockVideoPopup.vue?vue&type=template&id=7dcb1c08&scoped=true&"
import script from "./BlockVideoPopup.vue?vue&type=script&lang=ts&"
export * from "./BlockVideoPopup.vue?vue&type=script&lang=ts&"
import style0 from "./BlockVideoPopup.vue?vue&type=style&index=0&id=7dcb1c08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcb1c08",
  null
  
)

export default component.exports